/**
 * Runs the import a create dialog left for this board (`pending-import.ts`)
 * once the doc has synced — the sheet must exist before the agent can read
 * it, and the seed lands with the first sync. Honoured once per board view.
 */
import { useEffect, useRef } from "react";
import { useStore } from "zustand";

import type { BoardSession } from "../../core/session.js";
import { runPendingImport } from "./pending-import-run.js";
import type { AgentUiStore } from "./store.js";

export function useAgentImportOnOpen(session: BoardSession, ui: AgentUiStore): void {
  const synced = useStore(session.store, (s) => s.synced);
  const sheetId = useStore(session.store, (s) => s.sheetId);
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current || !synced || sheetId === null) return;
    ran.current = true;
    void runPendingImport(session, ui);
  }, [synced, sheetId, session, ui]);
}
